import { __assign, __rest } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { default as MuiTypography } from '@material-ui/core/Typography';
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        display1: theme.typography.display1,
        display2: theme.typography.display2,
    });
});
export var Typography = React.forwardRef(function (props, ref) {
    var className = props.className, variant = props.variant, other = __rest(props, ["className", "variant"]);
    var classes = useStyles(props);
    var muiVariant;
    var classNames = className;
    if (variant === 'display1' || variant === 'display2') {
        classNames = clsx(className, classes[variant]);
    }
    else {
        muiVariant = variant;
    }
    return (React.createElement(MuiTypography, __assign({ ref: ref, variant: muiVariant, className: classNames }, other)));
});
export default Typography;
//# sourceMappingURL=Typography.js.map